import React from 'react'
import DialogDefault from './_default'

const StatementDialog = (props) => {
    return <DialogDefault {...props} />

}

export default StatementDialog